import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const navItems = [
  { to: "/product", label: "Product" },
  { to: "/architecture", label: "Architecture" },
  { to: "/security", label: "Security" },
  { to: "/pricing", label: "Pricing" },
  { to: "/msp", label: "MSP" },
  { to: "/developers", label: "Developers" },
  { to: "/docs", label: "Docs" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 glass" data-testid="marketing-navbar">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="brand-logo">
          <Logomark />
          <div className="font-display font-bold text-base tracking-tight ink">TrustDmarc</div>
        </Link>
        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              data-testid={`nav-${it.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-3.5 py-2 text-sm font-medium rounded-full transition-colors ${
                  isActive ? "text-stone-900 bg-stone-100" : "text-stone-600 hover:text-stone-900"
                }`
              }
            >
              {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link to="/login" className="hidden sm:inline-flex text-sm font-medium text-stone-700 hover:text-stone-900 px-3" data-testid="navbar-signin">
            Sign in
          </Link>
          <Link to="/login" className="btn-accent text-sm" data-testid="navbar-start-free">
            Start free
          </Link>
        </div>
      </div>
    </header>
  );
}

export function Logomark({ size = 28 }) {
  return (
    <div
      className="rounded-lg flex items-center justify-center"
      style={{
        width: size, height: size,
        background: "linear-gradient(135deg, #FF5C1F 0%, #FF8A4C 100%)",
      }}
    >
      <svg viewBox="0 0 24 24" width={size * 0.55} height={size * 0.55} fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 7l9 6 9-6" />
        <rect x="3" y="5" width="18" height="14" rx="2" />
      </svg>
    </div>
  );
}
